import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB-3roS7xnc8gljLmQ_WmTcfhvbGhnAaGg",
  authDomain: "yanabee-af714.firebaseapp.com",
  databaseURL: "https://yanabee-af714-default-rtdb.firebaseio.com",
  projectId: "yanabee-af714",
  storageBucket: "yanabee-af714.firebasestorage.app",
  messagingSenderId: "893355922528",
  appId: "1:893355922528:web:5df36326ae30bb0a509f05",
  measurementId: "G-WH19CTYVCF"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

setPersistence(auth, browserLocalPersistence).catch(() => {
  // تجاهل الخطأ في البيئات التي لا تدعم التخزين المحلي
});

export default app;